import actionTypes from '../constants/actionTypes'
import { updateMidColFeed, midColVidGeoFilter } from './helpers'
import { flex as flexParser } from '../lib/transform/parsers/flex'
import selectn from 'selectn'

export default function clubhouseReducer(state = {}, action) {
  switch(action.type) {
    case actionTypes.UPDATE_TIMEZONE: {
      let edition = action.edition || {}
      let leftcolumn = state.leftColumn || {}
      let tzOptions = { zone: action.zone , zoneAbbr: action.zoneAbbr }
      leftcolumn = flexParser.updateLeftColumnTimezones(leftcolumn, tzOptions, edition)

      return Object.assign({}, state, {
        ...action.data,
        leftColumn: leftcolumn,
        zone: action.zone,
        zoneAbbr: action.zoneAbbr
      })
    }
    case actionTypes.GET_CLUBHOUSE:
      return Object.assign({}, state, {
        ...action.data,
        pageType: selectn('params.pageType', action)
      })

    case actionTypes.GET_MORE_MID_COL_FEED:
      midColVidGeoFilter (action.data, state.country, state)
      return updateMidColFeed(state, action.data)

    case actionTypes.GET_GEO_LOCATION:
      var { country } = action.data
      if(state.pageType === 'team') {
        midColVidGeoFilter (state, country)
      }
      return Object.assign({}, state, { country })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/clubhouse.js